<template>
    <DModal
        :show="showModal"
        :title="__('orders.check.manual_checks_tab.accept_modal.title')"
        is-confirm
        is-big
        :is-awaiting-validation="true"
        @confirm="accept"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <DTable
                :items="items"
                :fields="fields"
            >
                <template #checked="{item}">
                    <td>
                        <DFormCheck
                            :id="`checkbox_${item.product_id}`"
                            v-model="items[item.index].checked"
                            :checked="item.checked"
                        />
                    </td>
                </template>
                <template #comment="{item}">
                    <td>
                        <DInput
                            id="order-comment"
                            v-model="items[item.index].comment"
                            :invalid-feedback="errors[`items.${item.index}.comment`]"
                        />
                    </td>
                </template>
            </DTable>
        </DCard>
        <template
            v-if="errors[`error`]"
            #actions
        >
            <DAlert
                :color="'danger'"
                class="m-0 p-2"
            >
                {{ errors[`error`] }}
            </DAlert>
        </template>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'
import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    order: {
        type: Object,
        default: () => { return {} }
    }
})

const fields = ref([
    { key: 'checked', label: '', _style: { width: '10%' } },
    { key: 'name', label: __('orders.check.manual_checks_tab.accept_modal.name'), _style: { width: '30%' } },
    { key: 'interval', label: __('orders.check.manual_checks_tab.accept_modal.interval'), _style: { width: '10%' } },
    { key: 'price', label: __('orders.check.manual_checks_tab.accept_modal.price'), _style: { width: '10%' } },
    { key: 'discounts', label: __('orders.check.manual_checks_tab.accept_modal.discounts'), _style: { width: '10%' } },
    { key: 'comment', label: __('orders.check.manual_checks_tab.accept_modal.comment'), _style: { width: '30%' } }
])

const emit = defineEmits(['close-modal', 'confirm-modal'])

const items = getItems()

const errors = ref({})

function getItems () {
    const items = []

    props.order.products.forEach((item, index) => {
        items.push({
            index: index,
            checked: true,
            comment: null,
            name: item.name ?? null,
            price: item.price ?? null,
            interval: item.interval ?? null,
            discounts: item.discounts ?? 0
        })
    })

    return items
}

function accept () {
    const form = useForm({
        items: items
    })

    form.post(route('orders.psa.accept-order', { order: props.order.orderData.id }),
        {
            onSuccess: () => {
                emit('close-modal')
            },
            onError: (error) => {
                if (error) {
                    errors.value = error
                }
            }
        }
    )
}

</script>

<style scoped lang="scss">
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
